export default __webpack_public_path__ + "static/nbox-quick-5f631fa96d5cb2233496518d315685e7.jpg";